import { Typography, withStyles } from '@material-ui/core'
import React, { useState } from 'react'
import styles from './style'
import { CoreButton, CoreTextField } from 'src/components/core'
import { Icon } from '@iconify/react'

// use @giphy/js-fetch-api to fetch gifs, instantiate with your api key

const EmbedImage = props => {
  const { onPhotoClick, classes } = props
  const [urlText, setUrlText] = useState()
  return (
    <div className={classes.linkPanel}>
      <CoreTextField
        fullWidth
        marginTop={false}
        size="small"
        label={'Paste the image link'}
        onChange={e => setUrlText(e.target.value)}
      ></CoreTextField>
      <CoreButton
        variant="contained"
        onClick={() => {
          onPhotoClick(urlText)
        }}
      >
        Add Image
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(EmbedImage)
